module.exports = __webpack_public_path__ + "img/nrwlogo.f0476f8e.png";